import throttleModeOptions from './modeOptions';

const oauthThrottleSettingConfig = {
  name: 'OAuth Throttle Setting',
  endpoint: '/internal_admin/admin_kit/oauth_throttle_settings',
  modelKey: 'oauth_throttle_setting',
  titleField: 'key',
  csvExport: false,

  columns: [
    { name: 'key', title: 'Setting', type: 'link' },
    { name: 'value', title: 'Value' },
    { name: 'data_type', title: 'Type' },
  ],

  attributes: [
    { name: 'id', label: 'ID' },
    { name: 'key', label: 'Setting' },
    { name: 'value', label: 'Value' },
    { name: 'data_type', label: 'Type' },
  ],

  form: {
    fields: [
      {
        name: 'key',
        label: 'Setting',
        type: 'select',
        required: true,
        span: 2,
        options: [
          {
            id: 'mode',
            label: 'mode (off, log_only or enforced)',
            value: 'mode',
          },
          {
            id: 'limit_per_minute',
            label: 'limit_per_minute',
            value: 'limit_per_minute',
          },
          {
            id: 'limit_per_hour',
            label: 'limit_per_hour',
            value: 'limit_per_hour',
          },
        ],
        showOnEdit: () => false,
      },
      {
        name: 'value',
        label: 'Value',
        type: 'select',
        editOnly: true,
        span: 2,
        options: throttleModeOptions,
        showOnEdit: (record) => record.key === 'mode',
      },
      {
        name: 'value',
        label: 'Value',
        type: 'text',
        span: 2,
        showOnEdit: (record) => record.key !== 'mode',
        helpMessage:
          'mode: off, log_only or enforced (applications with their own mode ignore it). ' +
          'limit_per_minute / limit_per_hour: positive whole number of token requests per application + user. ' +
          'Without a row, the default comes from ENV (off, 10, 60).',
      },
    ],
  },
};

export default oauthThrottleSettingConfig;
